import Select, { StylesConfig, Props, ActionMeta } from 'react-select';
import { AsyncPaginate, LoadOptions } from 'react-select-async-paginate';

const colourStyles = (width?: number): StylesConfig => {
  return {
    control: (styles, state) => ({
      ...styles,
      borderRadius: state.menuIsOpen ? '8px 8px 0 0' : 8,
      borderColor: '#D8DAE5',
      borderWidth: 1,
      width,

      ':hover': {
        borderColor: '#D8DAE5',
      },
      cursor: 'pointer',
      minHeight: 42,
      boxShadow: 'none',
    }),
    container: styles => ({
      ...styles,
    }),
    option: styles => ({
      ...styles,
      color: '#161A30',
      cursor: 'pointer',
      backgroundColor: '#fff',
      fontSize: 14,
      padding: '6px 10px',

      ':hover': {
        backgroundColor: '#f5f7fb',
        borderRadius: '8px',
      },

      ':active': {
        ...styles[':active'],
        backgroundColor: '#fff',
      },
    }),
    indicatorSeparator: () => ({ backgroundColor: '#fff' }),
    dropdownIndicator: (styles, state) => ({
      ...styles,
      transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : '',
      color: state.selectProps.value ? 'transparent' : '#8F95B2',
      padding: '0',
      paddingRight: '0px',
      marginRight: 10,
      transition: 'none',
      ':disabled': {
        ...styles[':active'],
        backgroundColor: '#fff',
      },
      ':hover': {
        color: state.selectProps.value ? 'transparent' : '#8F95B2',
      },
    }),
    menu: styles => ({
      ...styles,
      borderRadius: '0 0 8px 8px',
      border: '1px solid #D8DAE5',
      borderTop: 0,
      marginTop: 0,
      boxShadow: 'none',
      zIndex: 10,
    }),
    valueContainer: styles => ({
      ...styles,
      padding: '0 12px',
      fontWeight: 400,
      '& input': {
        fontSize: '12px !important',
      },
    }),
    input: styles => ({
      ...styles,
      margin: 0,
      padding: 0,
    }),
    placeholder: styles => ({
      ...styles,
      color: '#8F95B2',
      fontSize: 12,
    }),
    singleValue: styles => ({
      ...styles,
      fontSize: '12px !important',
    }),
    clearIndicator: styles => ({
      ...styles,
      marginRight: '-28px',
      zIndex: 13,
      color: '#8f95b2',
      animation: 'fadeIn 2.5s',
      '@keyframes fadeIn': {
        '0%': { opacity: 0 },
        '100%': { opacity: 1 },
      },
    }),
  };
};

interface ICustomPicker extends Props {
  width?: number;
  isDisabled?: boolean;
}

const CustomPicker = ({ width, ...props }: ICustomPicker) => {
  return <Select styles={colourStyles(width)} {...props} />;
};

interface ICustomPickerAsyncPaginate {
  width?: number;
  placeholder?: string;
  onChange?: (newValue: any, actionMeta: ActionMeta<any>) => void;
  loadOptions: LoadOptions<any, any, any>;
  value: any;
  isClearable?: boolean;
  isDisabled?: boolean;
}

const CustomPickerAsyncPaginate = ({
  width,
  ...props
}: ICustomPickerAsyncPaginate) => {
  return <AsyncPaginate styles={colourStyles(width)} {...props} />;
};

export { CustomPicker, CustomPickerAsyncPaginate };
